import { ajax } from 'cadenza/api-client/api';

export function setLayerConditions (layerId: string, conditionHash: string): Promise<void> {
  return ajax<void>(`/layers/${layerId}/conditionValues`, {
    method: 'PUT',
    contentType: 'text/plain',
    data: conditionHash
  });
}
